import type { EasyModePlaceSelection } from "@/types/easyModePlace";

export function isCompleteEasyModePlace(
  place: EasyModePlaceSelection | null | undefined
): place is EasyModePlaceSelection {
  if (!place) return false;
  return Boolean(
    place.placeId?.trim() &&
      place.address?.trim() &&
      place.city?.trim() &&
      place.area?.trim() &&
      Number.isFinite(place.lat) &&
      Number.isFinite(place.lng)
  );
}

export function arePlacesDifferent(
  pickup: EasyModePlaceSelection,
  drop: EasyModePlaceSelection
): boolean {
  if (pickup.placeId === drop.placeId) return false;
  if (
    pickup.city.toLowerCase() === drop.city.toLowerCase() &&
    pickup.area.toLowerCase() === drop.area.toLowerCase()
  ) {
    return false;
  }
  return true;
}
